import {gql} from 'apollo-angular';

export const GET_SCHOOL_CLASSES_BY_SCHOOL = gql`
  query GetSchoolClassesBySchool {
    getSchoolClassesBySchool {
      id
      name
      numberStudents

      grade {
        id
        name
      }

      classCode
      teachers {
        id
      }

      classNumber
      classAddition

      schoolClassRankMin {
        points
        playtimeMinutes
        rank
        activityLevel
      }

      trophyStats {
        totalCount
        scoredCount
      }
      milestoneStats {
        totalCount
        scoredCount
      }

    }
  }
`;
